export enum BulkUserActionFailureReason {
  NOT_FOUND = 'not-found',
  NOT_PENDING_DELETION = 'not-pending-deletion',
  ALREADY_ANONYMIZED = 'already-anonymized',
  GRACE_PERIOD_EXPIRED = 'grace-period-expired',
  ROLE_NOT_PERMITTED = 'role-not-permitted',
  FREE_TRIAL_USER_LIMIT_REACHED = 'free-trial-user-limit-reached',
  SEQUENCE_FAILED = 'sequence-failed',
}
